import { render, staticRenderFns } from "./FileNfe.vue?vue&type=template&id=7fa72438&scoped=true&"
import script from "./FileNfe.vue?vue&type=script&lang=js&"
export * from "./FileNfe.vue?vue&type=script&lang=js&"
import style0 from "./FileNfe.vue?vue&type=style&index=0&id=7fa72438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa72438",
  null
  
)

export default component.exports